import React from 'react';
import { IconButton, IconHelp, Popover } from '@lmig/lmds-react';

export interface IPopoverProps {
  children: JSX.Element | string;
}

const PopoverComponent = ({ children }: IPopoverProps) => (
  <span>
    <Popover
      className='demo-class'
      data-testid='popover-test-id'
      align='end'
      trigger={
        <IconButton
          background='transparent'
          data-testid='popover-button-test-id'
        >
          <IconHelp color='teal' size='16' />
        </IconButton>
      }
    >
      {children}
    </Popover>
  </span>
);

export default PopoverComponent;
